import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { order } from "../app/schema";

export const GET_ORDERS = "GET_ORDERS";
export const GET_ORDER = "GET_ORDER";
export const PATCH_ORDERS = "PATCH_ORDERS";
export const DELETE_ORDER = "DELETE_ORDER";

export const SET_IS_REMOVE_ORDER_MODAL_VISIBLE = "SET_IS_REMOVE_ORDER_MODAL_VISIBLE";
export const SET_IS_EDIT_ORDER_MODAL_VISIBLE = "SET_IS_EDIT_ORDER_MODAL_VISIBLE";

// Requests

const getOrdersGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/orders?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getOrderGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/orders/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchOrder = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/orders/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteOrders = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/orders/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function getOrders(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_ORDERS],
    payload: {
      promise: getOrdersGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          data.orders.forEach(function(item, index) {
            item.products = JSON.parse(item.products);
          });
          return normalize(data, { orders: arrayOf(order) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getOrder(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_ORDER],
    payload: {
      promise: getOrderGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          data.products = JSON.parse(data.products);
          return normalize(data, order);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateOrder(data, uid) {
  data.products = JSON.stringify(data.products);
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_ORDERS],
    payload: {
      promise: patchOrder(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, order);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeOrder(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_ORDER],
    payload: {
      promise: deleteOrders(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsRemoveOrderModalVisible(value) {
  return {
    type: SET_IS_REMOVE_ORDER_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

export function setIsEditOrderModalVisible(value) {
  return {
    type: SET_IS_EDIT_ORDER_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/orders/actions.js